export interface CancelablePromise<T> extends Promise<T> {
    cancel(): void;
}

export function makeCancelable<T>(promise: Promise<T>): CancelablePromise<T> {
  let hasCanceled = false;

  const wrappedPromise: any = new Promise((resolve, reject) => {
    promise.then((val) =>
      hasCanceled ? reject({isCanceled: true}) : resolve(val)
    );
    promise.catch((error) =>
      hasCanceled ? reject({isCanceled: true}) : reject(error)
    );
  });

  wrappedPromise.cancel = () => {
      hasCanceled = true;
  };

  return wrappedPromise;
};



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/util/cancelablePromise.ts
 **/